document.querySelectorAll('.faq-accordion > dt > button').forEach(button => {
  button.setAttribute('aria-expanded', 'false');
  let panel = button.parentElement.nextElementSibling;
  panel.setAttribute('aria-hidden', 'true');
  panel.style.display = 'none';

  button.addEventListener('click', () => {
    let expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !expanded);
    panel.setAttribute('aria-hidden', expanded);

    if (expanded) {
      panel.style.display = 'none';
    } else {
      panel.style.display = 'block';
    }
  });
});
